import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";
import Reconciliations from "../../components/Reconciliation/Reconciliations";

class ReconciliationScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={"Reconciliation"}
            titleClassName="text-primary"
          />
          <Reconciliations />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ReconciliationScreen);
